import { get, post } from '@/plugins/axios.js'

// 如果我们的项目需要代理多个地址，就不能在axios中设置 axios.defaults.baseURL
// 应该在此处动态的拼接url！
const data = process.env.VUE_APP_DATA
const baseApi = process.env.VUE_APP_BASE_API
const fwClient = process.env.VUE_APP_FW_CLIENT;
const jsonData = {

  /**
   * 获取雷达图像
   */
  getRadarImages () {
    // return get(`${data}/radarpic/index.json`)
    return get(`${data}/radarCut.json`)
  },
  /**
   * 根据时间获取雷达图像
   */
  getRadarImagesTimes (option) {
    // return get(`${data}/radarpic/index.json`)
    return get(`${fwClient}/radar/gainRadarList?stime=${option.stime}&etime=${option.etime}`);
  },
  /**
  *获取卫星云图数据
  * @param {String} option
  */
  getCloudData () {
    return get(`${data}/cloud/3D/index.json`)
  },
  /**
   * 获取广州地图
   * @returns
   */
  getFsMap () {
    // return get('resoures/BCGZ_geo.json')
    return get('resoures/fs.json')
  },

  getFsTownMap () {
    // return get('resoures/BCGZ_geo.json')
    return get('resoures/fstown.geojson')
  },

  getTownMap (town) {
    // return get('resoures/BCGZ_geo.json')
    return get(`resoures/alarm_map/${town}.geojson`)
  },

  /**
   * 获取风场数据
   * @returns
   */
  getWindData () {
    return get('resoures/gfs.json')
  },

  /**
   * 获取广东地图
   * @returns
   */
  getGdMap () {
    return get('resoures/GD.json')
  },

  /**
   * 获取二广高速站点数据
   * @returns
   */
  getEGData () {
    return get('resoures/egline.json')
  }

}
export default jsonData
